module.exports = __webpack_public_path__ + "static/media/apartment14.8c24974d.jpg";